// Import libs
import { createWebHistory, createRouter } from 'vue-router';
// Import Components (Alphabetical)
import DoMore from '@/components/landing/DoMore.vue'
import Error from '@/components/Error.vue'
import ExternalApiView from "./components/ExternalApi.vue";
import Features4 from '@/components/features/Features4.vue'
import Gallery from '@/components/Gallery.vue'
import Loading from '@/components/Loading.vue'
import Home from './components/Home.vue';
import Landing2 from '@/components/landing/Landing2.vue'
import Landing3 from '@/components/landing/Landing3.vue'
import Landing4 from '@/components/landing/Landing4.vue'
import LearnMore from './components/LearnMore.vue';
import Login from './components/LoginForm.vue';
import Logout from './components/Logout.vue';
import Modern from './components/content/Modern.vue';
import Pricing4 from './components/pricing/Pricing4.vue';
import PrivacyPolicy from './components/content/PrivacyPolicy.vue';
import ShareViewer from '@/components/ShareViewer.vue'
import Signup from './components/Signup.vue';
import SignupOld from './components/SignupOld.vue';
import Tasks from './components/Tasks.vue';
import TaskEntry from '@/components/TaskEntry.vue';
import Tour from './components/Tour.vue';
import Tour4 from './components/tours/Tour4.vue';
import TaskDetail from './components/TaskDetail.vue';
import Profile from './components/Profile.vue';
import StripeDemo from './components/dev/StripeDemo.vue';
import UI from './components/UI.vue';
import UserAgreement from './components/content/UserAgreement.vue';
import UserStats from './components/UserStats.vue';
import Welcome from './components/Welcome.vue';
import WordCloud from './components/WordCloud.vue';

// Import Others
import { authGuard } from "./auth/authGuard";
import { adminGuard } from "./auth/adminGuard";

const routes = [
    {
		path: "/external-api",
		name: "external-api",
		component: ExternalApiView,
		beforeEnter: authGuard
	},
	{ 
		path: '/', 
		name: 'index',
		beforeEnter: authGuard,
		redirect: to => {
			// 20260128 -- Copilot (Claude Sonnet 4.5) -- Redirect authenticated users to dashboard
			// WHY: Root path should go to dashboard, not signup form
			return { name: 'dashboard' }
		}
	},
	{ 
		path: '/error', 
		component: Error, 
		name: 'error',
		children: [
			{
				path: ':message',
				component: Error,
			}
		]
	},
	{ 
		path: '/home', 
		component: Landing4, 
		name: 'home'
	},
	{ 
		path: '/landing/do-more', 
		component: DoMore, 
		name: 'do-more'
	},
	{ 
		path: '/learn-more', 
		component: LearnMore, 
		name: 'learn-more'
	},
	{ 
		path: '/dashboard', 
		component: UserStats, 
		name: 'dashboard',
		beforeEnter: authGuard
	},
	{ 
		path: '/features/4', 
		component: Features4, 
		name: 'features4'
	},
	{ 
		path: '/gallery', 
		component: Gallery, 
		name: 'gallery-public'
	},
	{ 
		path: '/gallery/:gallery', 
		component: Gallery, 
		name: 'gallery',
		beforeEnter: authGuard
	},
	{ 
		path: '/gallery/:gallery/:userId', 
		component: Gallery, 
		name: 'public-user-gallery',
		beforeEnter: authGuard
	},
	{ 
		path: '/gallery/:gallery/:templateId', 
		component: Gallery, 
		name: 'gallery-item',
		beforeEnter: authGuard
	},
	{ 
		path: '/landing/2', 
		component: Landing2, 
		name: 'landing2'
	},
	{ 
		path: '/landing/3', 
		component: Landing3, 
		name: 'landing3'
	},
	{ 
		path: '/landing/4', 
		component: Landing4, 
		name: 'landing4'
	},
	{ 
		path: '/login', 
		component: Signup, 
		name: 'login',
		beforeEnter: authGuard,
	},
	{ 
		path: '/logout', 
		component: Logout, 
		name: 'logout'
	},
	{ 
		path: '/modern', 
		component: Modern, 
		name: 'modern', 
	},
	{ 
		path: '/pricing/4', 
		component: Pricing4, 
		name: 'pricing4'
	},
	{ 
		path: '/privacy-policy', 
		component: PrivacyPolicy, 
		name: 'privacy-policy', 
	},
	{ 
		path: '/signup', 
		component: Signup, 
		name: 'signup',
		beforeEnter: authGuard,
	},
	{ 
		path: '/signup/old', 
		component: SignupOld, 
		name: 'signup-old',
		beforeEnter: authGuard,
	},
	{ 
		path: '/gtd/tasks', 
		component: Tasks, 
		name: 'tasks', 
		beforeEnter: authGuard,
		children: [
			{
				path: 'inbox',
				component: Tasks,
				beforeEnter: authGuard
			}
		]
	},
	{ 
		path: '/tasks', 
		component: Tasks, 
		name: 'tasks', 
		beforeEnter: authGuard,
		children: [
			{
				path: ':filterName',
				component: Tasks,
				beforeEnter: authGuard
			}
		]
	},
	{
		path: '/tasks/context/:context',
		component: Tasks,
		name: 'tasks-context',
		beforeEnter: authGuard
	},
	{
		path: '/tasks/search',
		component: Tasks,
		name: 'tasks-search',
		beforeEnter: authGuard
	},
	{
		path: '/tasks/system-filter',
		component: Tasks,
		name: 'tasks-system-filter',
		beforeEnter: authGuard
	},
	{ 
		path: '/tasks/create/new', 
		component: TaskEntry, 
		name: 'createTask', 
		beforeEnter: authGuard,
	},
	{
		path: '/tasks/detail/:taskId',
		component: TaskDetail,
		name: 'task-detail',
		beforeEnter: authGuard
	},
	{
		path: '/tasks/folder/:folder',
		component: Tasks,
		name: 'tasks-folder',
		beforeEnter: authGuard
	},
	{
		path: '/tasks/ps/:filter',
		component: Tasks,
		name: 'tasks-ps',
		beforeEnter: authGuard
	},
	{
		path: '/tasks/priority/:priority',
		component: Tasks,
		name: 'tasks-priority',
		beforeEnter: authGuard
	},
	{
		path: '/tasks/status/:status',
		component: Tasks,
		name: 'tasks-status',
		beforeEnter: authGuard
	},
	{ 
		path: '/tour', 
		component: Tour, 
		name: 'tour',
	},
	{ 
		path: '/tours/4', 
		component: Tour4, 
		name: 'tour4',
	},
	{ 
		path: '/profile', 
		component: Profile, 
		name: 'profile',
		beforeEnter: authGuard,
		children: [
			{
				path: '/profile/:section',
				component: Profile,
				beforeEnter: authGuard
			},
		]
	},
	{ 
		path: '/dev/stripe-demo', 
		component: StripeDemo, 
		name: 'stripe-demo',
		beforeEnter: authGuard
	},
	{ 
		path: '/dev/loading', 
		component: Loading, 
		name: 'loading-demo'
	},
	{ 
		path: '/welcome', 
		component: Welcome, 
		name: 'welcome',
		beforeEnter: authGuard
	},
	{ 
		path: '/wordcloud', 
		component: WordCloud, 
		name: 'wordcloud',
		beforeEnter: authGuard
	},
	{ 
		path: '/ui', 
		component: UI, 
		name: 'ui'
	},
	{
		path: '/user-agreement',
		component: UserAgreement,
		name: 'user-agreement',
	},
	// 20260419 -- Copilot (Claude Sonnet 4.6) -- /settings/mcp removed; AI Connections moved into Profile > Integrations tab
	// 20260405 -- Copilot (Claude Sonnet 4.6) -- Admin dashboard route (stg-admin role required)
	{
		path: '/admin/dashboard',
		component: () => import('@/components/AdminDashboard.vue'),
		name: 'admin-dashboard',
		beforeEnter: adminGuard
	},
	// 20260506 -- Copilot (Claude Sonnet 4.6) -- Public share viewer; no authGuard intentionally
	{
		path: '/share/:token',
		component: ShareViewer,
		name: 'share-viewer',
	},
	/*
    { path: '/register', component: Register, name: 'register' },

    { path: '/student/:id', component: Student, name: 'student' },
	{ path: '/redirect', component: Redirect, name: 'redirect' },
	*/
];

const router = createRouter({
	history: createWebHistory(),
	// base: process.env.BASE_URL, 
	routes});

export default router;